module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_9006.3ec52811.png";